import { RateGroup } from "@/helpers/types/types.ts";
import { useMemo } from "react";

export const useGetLowestPriceFrom = (rg: RateGroup) => {
  return useMemo(
    () =>
      rg.ratePlans?.reduce((prev, curr) => (prev.lowestPrice < curr.lowestPrice ? prev : curr))?.lowestPrice,
    [rg],
  );
};
